/**
 * Active Brand chrome for the MA brand/master-account sidebar card.
 *
 * Authenticated user → header/profile
 * Active Master Account → tenant authorization
 * Active Brand → this sidebar card only
 *
 * Never invent a Brand. Never fall back to tenant.businessName / userInfo.
 */
export function resolveActiveBrandChrome(currentBrand) {
  if (!currentBrand || typeof currentBrand !== "object") return null;
  const id = String(currentBrand.id || "").trim();
  const name = String(currentBrand.name || "").trim();
  if (!id || !name) return null;
  const logoUrl =
    String(currentBrand.logoUrl || currentBrand.logo || "").trim() || null;
  return { id, name, logoUrl };
}

export const CURRENT_BRAND_STORAGE_KEY = "currentBrand";
